import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../config/Translate";
import axios from "axios";
import {defaultVariabls} from "../../../../config/index";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import AppAnimate from "../../../components/AppAnimate";
import AppCard from "../../../components/layouts/components/AppCard";
import Grid from "@material-ui/core/Grid/Grid";
import {connect, setStore} from "trim-redux";
import BreadCrumbs from "../../../components/elements/BreadCrumbs";
import AppCardLoaderFields from "../../../components/Skeletons/AppCardLoaderFields";
import Typography from "@material-ui/core/Typography/Typography";
import {currencySymbol, price} from "../../../../config/values";
import SubTitle from "../../../components/elements/SubTitle";
import moment from "jalali-moment";
import SingleOrderItem from "../components/SingleOrderItem";
import Divider from "@material-ui/core/Divider/Divider";
import FiberManualRecordRoundedIcon from '@material-ui/icons/FiberManualRecordRounded';
import Button from "@material-ui/core/Button/Button";
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';
import GetConfirmationText from "../../../components/elements/GetConfirmationText";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import ShippingConfirmationButton from "./ShippingConfirmationButton";
import Alert from "@material-ui/lab/Alert/Alert";
import ReceiptRoundedIcon from "@material-ui/icons/ReceiptRounded";
import AddTicketModalUser from "../../tickets/add_ticket/AddTicketModalUser";
import EditShippingCodeBtn from "./EditShippingCodeBtn";

class CheckOrder extends React.Component {

    state = {
        factor:null,
        SubmitLoading:false,
        id:this.props.match.params.id,
        loading:true
    };
    classes = this.props.classes;
    async componentDidMount(){
        await this.loadData();

    }
    componentDidUpdate(prevProps){
        if(this.state.id !== this.props.match.params.id){
            this.setState({
                id: this.props.match.params.id
            })
        }
    }
    async loadData(){
        this.setState({
            loading:true,
        })
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/factor/get_for_shop/${this.state.id}`, config)
                .then(response => {
                    this.setState({
                        factor:response.data,
                        loading:false
                    })

                }).catch(error => {
                    console.log(error.response)
                    this.setState({
                        loading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
        }
    }
    reload(){
        this.props.enqueueSnackbar(Translate.factorConfirmedToPurchase, {
            variant: 'success',
        });
        this.props.history.push(`/shop-orders`)

    }
    async handleConfirmOrder(status){
        let {factor} = this.state;
        let data = new FormData();
        data.append('id', factor.orders[0].id);
        data.append('status', status);

        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        await axios.post(`${defaultVariabls.url}/factor/change_order_status`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.dataEdited, {
                    variant: 'success',
                });
                this.setState({
                    loading:true,
                })
                this.loadData();

            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.dataEditingFailed, {
                    variant: 'error',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                });
            });

    }
    render(){
        let {factor} = this.state;
        let {user} = this.props;
        return (
            <AppAnimate animation='transition.slideUpIn' delay={200} title={Translate.viewOrder}>
                {

                    <Grid container spacing={2} justify="center">
                        <Grid item xs={12} md={11}>
                            <AppCard
                                title={Translate.viewOrder}
                                action={
                                    <BreadCrumbs  firstText={Translate.orders} firstLink="/shop-orders" secondText={Translate.viewOrder}/>
                                }>
                                {
                                    this.state.loading ?
                                        <AppCardLoaderFields/>
                                        :
                                        <Grid container spacing={2} justify="center" alignItems="center">
                                            <Grid item xs={12} style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                                                <SubTitle align="left">{Translate.orderDetails}</SubTitle>
                                                <div style={{display:"flex",alignItems:"center"}}>
                                                    {
                                                        (factor.status !== "rejected" && factor.status !== "not_payed" && factor.status !== "need_verification") ?
                                                            <>
                                                                {
                                                                    factor.orders[0].status === "pending" ?
                                                                        <>
                                                                            <GetConfirmationText
                                                                                tooltip={Translate.changeStatus}
                                                                                className={this.classes.link}
                                                                                style={{
                                                                                    cursor:"pointer",
                                                                                    color: this.props.primary_color,
                                                                                    marginBottom:0,
                                                                                    border: "1px solid #3887bf",
                                                                                    padding: "5px 8px",
                                                                                    borderRadius: 6,
                                                                                    marginLeft:5,
                                                                                }}
                                                                                handleAction={() => this.handleConfirmOrder('ok')}
                                                                                question={Translate.isOrderReceivedToYouShop}
                                                                                icon={<CheckBoxIcon/>}
                                                                                color={this.props.primary_color}
                                                                            >
                                                                                {Translate.receivingConfirmationShop}
                                                                            </GetConfirmationText>
                                                                            <GetConfirmationText
                                                                                tooltip={Translate.changeStatus}
                                                                                className={this.classes.link}
                                                                                style={{
                                                                                    cursor:"pointer",
                                                                                    color: "#ed1d1d",
                                                                                    marginBottom:0,
                                                                                    border: "1px solid #ed1d1d",
                                                                                    padding: "5px 8px",
                                                                                    borderRadius: 6,
                                                                                    marginLeft:5
                                                                                }}
                                                                                handleAction={() => this.handleConfirmOrder('reject')}
                                                                                question={Translate.rejectOrderShopQ}
                                                                                icon={<CheckBoxIcon/>}
                                                                                color={this.props.primary_color}
                                                                            >
                                                                                {Translate.rejectOrderShop}
                                                                            </GetConfirmationText>
                                                                        </>
                                                                        :
                                                                        factor.orders[0].status === "ready" ?
                                                                            <Typography>
                                                                                <ShippingConfirmationButton
                                                                                    transfer_type={factor.transfer_type}
                                                                                    order_id={factor.orders[0].id}
                                                                                    reload={
                                                                                        () => this.loadData()
                                                                                    }
                                                                                />
                                                                            </Typography>
                                                                            : null
                                                                }
                                                            </> : null
                                                    }
                                                    {
                                                        !!(factor.status !== "rejected" && factor.status !== "not_payed" && factor.status !== "need_verification" && factor.orders[0].status !== "rejected" && factor.orders[0].status !== "payed_to_shop") &&
                                                        <AddTicketModalUser
                                                            receiver_id={factor.user_id}
                                                            factor_id={factor.id}
                                                            size="medium"
                                                            title={Translate.sendMessageToBuyer}
                                                        />
                                                    }
                                                    {
                                                        (factor.status !== "not_payed" && factor.status !== "need_verification" && factor.status !== "rejected" && factor.orders[0].status !== "pending" && factor.orders[0].status !== "rejected") &&
                                                        <>
                                                            <Button
                                                                color="primary"
                                                                component={"a"}
                                                                href={`${defaultVariabls.website}/view/receipt/${factor.number}/${factor.orders[0].id}`}
                                                                target="_blank"
                                                                variant="outlined"
                                                                style={{margin:"0 5px"}}
                                                                startIcon={<ReceiptRoundedIcon/>}
                                                            >
                                                                {Translate.viewReceipt}
                                                            </Button>
                                                            <Button
                                                                color="primary"
                                                                component={"a"}
                                                                href={`${defaultVariabls.website}/view/order-invoice/${factor.number}/${factor.orders[0].id}`}
                                                                target="_blank"
                                                                variant="outlined"
                                                                startIcon={<ChevronLeftRoundedIcon/>}

                                                            >
                                                                {Translate.viewInvoice}
                                                            </Button>
                                                        </>
                                                    }
                                                </div>

                                            </Grid>
                                            {
                                                (factor.orders[0].status === "done" || factor.orders[0].status === "received") &&
                                                <Grid item xs={12}>
                                                    <Alert >
                                                        {
                                                            factor.orders[0].auto_pay === 1 ?
                                                                <span>
                                                                {Translate.pay_to_shop_text1} <strong>{`${moment(factor.orders[0].checkout_at).locale('fa').format( 'HH:mm , YYYY/M/D')}`}</strong> {Translate.pay_to_shop_text2}
                                                                </span> :
                                                                <span>
                                                                    {Translate.autoPayIsOff}
                                                                </span>
                                                        }
                                                    </Alert>
                                                </Grid>
                                            }
                                            <Grid item xs={12}>
                                                <div className="order-items-holder">
                                                    <Typography>{Translate.order_status} <span className={"order_badge "+factor.orders[0].status}>{Translate[factor.orders[0].status]}</span> </Typography>
                                                    <Typography>
                                                        <FiberManualRecordRoundedIcon fontSize="small"/>
                                                    </Typography>
                                                    <Typography>{Translate.factor_number} <span className="result">{factor.number}</span></Typography>
                                                    <Typography>
                                                        <FiberManualRecordRoundedIcon fontSize="small"/>
                                                    </Typography>
                                                    <Typography>
                                                        {Translate.created_at_factor}
                                                        <span className="result">
                                                            {`${moment(factor.created_at).locale('fa').format( 'YYYY/M/D')}`}
                                                        </span>
                                                    </Typography>
                                                </div>
                                            </Grid>
                                            {/*<Grid item xs={12}>
                                                <Divider/>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <div className="order-items-holder mb-15">
                                                    <Typography>{Translate.user_delivery} <span className="result">{factor.user.first_name} {factor.user.last_name}</span></Typography>
                                                    <Typography>
                                                        <FiberManualRecordRoundedIcon fontSize="small"/>
                                                    </Typography>
                                                    <Typography>{Translate.mobileNumber} <span className="result">{factor.user.mobile}</span></Typography>
                                                </div>
                                                <div className="order-items-holder">
                                                    <Typography>{Translate.address} <span className="result">{factor.address.province} / {factor.address.city}، {factor.address.address}، {Translate.postal_code} {factor.address.postal_code}.  </span></Typography>
                                                </div>
                                            </Grid>*/}
                                            <Grid item xs={12}>
                                                <Divider/>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <div className="order-items-holder">
                                                    <Typography>{Translate.priceName}<span className="result">{price(factor.orders[0].total_price_payed)} {currencySymbol}</span></Typography>
                                                    <Typography>
                                                        <FiberManualRecordRoundedIcon fontSize="small"/>
                                                    </Typography>
                                                    <Typography>{Translate.discounts} <span className="result"> {price(factor.orders[0].total_discount_price)} {currencySymbol}</span></Typography>
                                                    <Typography>
                                                        <FiberManualRecordRoundedIcon fontSize="small"/>
                                                    </Typography>
                                                    <Typography>{Translate.transfer_price} <span className="result">
                                                            {
                                                                factor.orders[0].total_transfer_price > 0 ?
                                                                    <>
                                                                        {price(factor.orders[0].total_transfer_price)} {currencySymbol}
                                                                    </> :
                                                                    Translate.free
                                                            }
                                                        </span>
                                                        {" "}
                                                        {factor.transfer_type === "courier" && <strong style={{color:"green"}}>{(Translate.transferCourier)}</strong>}
                                                    </Typography>
                                                    <Typography>
                                                        <FiberManualRecordRoundedIcon fontSize="small"/>
                                                    </Typography>
                                                    {
                                                        (!!factor.orders[0].discount && !!factor.orders[0].total_discount_code_price) &&
                                                        <>
                                                            <Typography>{Translate.discount_code} <span className="result"> {price(factor.orders[0].total_discount_code_price)} {currencySymbol} - {factor.orders[0].discount}</span></Typography>
                                                            <Typography>
                                                                <FiberManualRecordRoundedIcon fontSize="small"/>
                                                            </Typography>
                                                        </>
                                                    }
                                                    <Typography>{Translate.site_commission} <span className="result"> {price(factor.orders[0].commission)} {currencySymbol}</span></Typography>
                                                    <Typography>
                                                        <FiberManualRecordRoundedIcon fontSize="small"/>
                                                    </Typography>
                                                    <Typography>{Translate.total_price_to_get} <span className="result">{price(factor.orders[0].provider_checkout_price)} {currencySymbol}</span></Typography>
                                                    {
                                                        !!factor.orders[0].shipping_code &&
                                                        <>
                                                            <Typography>
                                                                <FiberManualRecordRoundedIcon fontSize="small"/>
                                                            </Typography>
                                                            <Typography>{Translate.shipping_code} <span className="result">{factor.orders[0].shipping_code}</span>
                                                                {
                                                                    factor.transfer_type === "post" &&
                                                                        <EditShippingCodeBtn
                                                                            order_id={factor.orders[0].id}
                                                                            shipping_code={factor.orders[0].shipping_code}
                                                                            reload={
                                                                                () => this.props.reload()
                                                                            }
                                                                        />
                                                                }
                                                            </Typography>
                                                        </>
                                                    }
                                                    {
                                                        !!factor.orders[0].shipment_at &&
                                                        <>
                                                            <Typography>
                                                                <FiberManualRecordRoundedIcon fontSize="small"/>
                                                            </Typography>
                                                            <Typography>{Translate.shipment_at} <span className="result">{`${moment(factor.orders[0].shipment_at).locale('fa').format( 'YYYY/M/D H:mm')}`}</span></Typography>
                                                        </>
                                                    }
                                                </div>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <SubTitle align="left">{Translate.productsList}</SubTitle>
                                            </Grid>
                                            <Grid item xs={12}>
                                                {
                                                    factor.order_items.map((item,index) => (
                                                        <SingleOrderItem reload={() => this.reload()} factor_status={factor.status} key={index} item={item} no_shop/>
                                                    ))
                                                }
                                            </Grid>
                                        </Grid>
                                }
                            </AppCard>
                        </Grid>
                    </Grid>
                }
            </AppAnimate>

        );
    }
}
const mstp = state => ({
    user: state.user,
});
export default withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(CheckOrder))));